var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status)?[(_vm.status.name)?_c('div',[_vm._v("\n      "+_vm._s(_vm.status.name)+"\n    ")]):_vm._e(),(_vm.status.name)?_c('div',{staticClass:"status text-muted"},[_c('span',[_vm._v(_vm._s(_vm.status.active)+" / "+_vm._s(_vm.status.total))])]):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }